import React from "react";
import { Link } from "react-router-dom";

import { logo, facebook, twitter, instagram } from "../../assets";
const Footer = () => {
  return (
    <footer className="bg-secondary/30 w-full flex justify-center items-center flex-col sm:px-16 px-6">
      <div className="flex sm:flex-row flex-col w-full justify-between items-start py-10 sm:gap-16 gap-6">
        <img src={logo} className="w-[160px]" alt="logo" />
        <section className="basis-8/12 flex sm:flex-row gap-4 flex-col items-start justify-between px-4">
          <section className="flex flex-col gap-y-4">
            <h4 className="uppercase text-[18px] leading-8 text-secondary tracking-[3px]">
              About Us
            </h4>
            <ul className="list-none flex-col flex">
              <Link>
                <li className="text-[16px] leading-8 text-textPrimary">
                  Entrance Work
                </li>
              </Link>
              <Link>
                <li className="text-[16px] leading-8 text-textPrimary">
                  Careers
                </li>
              </Link>
              <Link>
                <li className="text-[16px] leading-8 text-textPrimary">News</li>
              </Link>
            </ul>
          </section>
          <section className="flex flex-col gap-y-4">
            <h4 className="uppercase text-[18px] leading-8 text-secondary tracking-[3px]">
              For Students
            </h4>
            <ul className="list-none flex-col flex">
              <Link>
                <li className="text-[16px] leading-8 text-textPrimary">
                  Learn
                </li>
              </Link>
              <Link>
                <li className="text-[16px] leading-8 text-textPrimary">
                  Solutions
                </li>
              </Link>
              <Link>
                <li className="text-[16px] leading-8 text-textPrimary">
                  Entrance
                </li>
              </Link>
            </ul>
          </section>
          <section className="flex flex-col gap-y-4">
            <h4 className="uppercase text-[18px] leading-8 text-secondary tracking-[3px]">
              For Teachers
            </h4>
            <ul className="list-none flex-col flex">
              <Link>
                <li className="text-[16px] leading-8 text-textPrimary">
                  Practice for Teachers
                </li>
              </Link>
              <Link>
                <li className="text-[16px] leading-8 text-textPrimary">Live</li>
              </Link>
              <Link>
                <li className="text-[16px] leading-8 text-textPrimary">
                  Adapt in your School
                </li>
              </Link>
            </ul>
          </section>
          <section className="flex flex-col gap-y-4">
            <h4 className="uppercase text-[18px] leading-8 text-secondary tracking-[3px]">
              Resources
            </h4>
            <ul className="list-none flex-col flex">
              <Link>
                <li className="text-[16px] leading-8 text-textPrimary">
                  Contact Us
                </li>
              </Link>
              <Link>
                <li className="text-[16px] leading-8 text-textPrimary">
                  Help Center
                </li>
              </Link>
            </ul>
          </section>
        </section>
        <section className="basis-2/12 flex flex-row gap-2 pl-4">
          <a href="https://facebook.com" target="_blank" rel="noreferrer">
            <img src={facebook} alt="facebook logo" />
          </a>
          <a href="https://twitter.com" target="_blank" rel="noreferrer">
            <img src={twitter} alt="twitter logo" />
          </a>
          <a href="https://instagram.com" target="_blank" rel="noreferrer">
            <img src={instagram} alt="instagram logo" />
          </a>
        </section>
      </div>

      <div className="w-full flex justify-between flex-row border-t-[1px] border-t-secondary py-10">
        <span className="font-thin text-[16px] text-textSecondary">
          Copyright &copy; 2022 Intrance.
          <br className="sm:hidden" /> All Rights Reserved
        </span>
        <div className="flex gap-[60px] text-textSecondary">
          <Link to="#">Privacy Policy</Link>
          <Link to="#">Terms of Use</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
